import { useState } from 'react';
import MenuButton from './MenuButton';
import openInNewTabAttr from '../../../services/helpers/openInNewTabAttr';
import './DesktopMenu.sass';

const DesktopMenu = ({ menuItems }) => {
  const [menuVisibility, setMenuVisibility] = useState(false);

  return (
    <div className='desktop-menu-wrapper'>
      <MenuButton
        onClick={() => setMenuVisibility(!menuVisibility)}
        active={menuVisibility}
      />

      {menuVisibility && (
        <div className='desktop-menu-menu'>
          {menuItems.map(({ id, link, newTab, title }) => (
            <a key={id} href={link} {...openInNewTabAttr(newTab)}>
              {title}
            </a>
          ))}
        </div>
      )}
    </div>
  );
};

export default DesktopMenu;
